// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'lib-flexible'
import 'babel-polyfill'
// import 'lib-flexible/flexible'
import Vue from 'vue'
import App from './App'
import router from './router'
import api from 'common/api/index'
import 'mint-ui/lib/style.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.use(api)
Vue.config.productionTip = false

sso.event('logged', function (user) {// eslint-disable-line
  window.sessionStorage.setItem('s', user.getId())
  window.sessionStorage.setItem('username', user.getUsername())
})
sso.event('notLogged', function () {}) // eslint-disable-line
sso.event('afterLogout', function () {}) // eslint-disable-line

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js